import { now } from "lodash";
import { useState, useEffect, useMemo } from "react";
import { administrationService } from "../dependencyInjection";
import { PasswordExpiration, User } from "../services/AdministrationService";

type UseGetUsersList = (paramSort?: number) => void;
type UseCreateUser = (userInfo: User) => Promise<boolean>;
type UseUpdateUser = (userInfo: User) => void;
type UseDeleteUser = (userId: number) => void;
type UseSetExpirePeriod = (period: string) => void;
type UseGetExpirePeriod = () => void;
type UseAdministrationResult = [
  User[],
  boolean,
  UseGetUsersList,
  UseCreateUser,
  UseUpdateUser,
  UseDeleteUser,
  UseSetExpirePeriod,
  UseGetExpirePeriod,
  PasswordExpiration
];

export function useAdministration(): UseAdministrationResult {
  const [users, setUsers] = useState<User[]>([]);
  const [expirePeriod, setExpirePeriod] = useState<PasswordExpiration>({ startDate: Date.now(), expirationMonthCount: 12 });
  const [pendind, setPending] = useState(false);
  useEffect(() => {
    
    const sub = administrationService.users$.subscribe((userList) => {
      setUsers(userList);
    });
    const subPass = administrationService.passwordExpire$.subscribe((password) => {
      setExpirePeriod(password);
    });
    const subLoading = administrationService.loading$.subscribe((loading) => {
      setPending(loading);
    });
    return () => {
      sub.unsubscribe();
      subPass.unsubscribe();
      subLoading.unsubscribe();
    };
  }, []);

  const getUsersList = useMemo<UseGetUsersList>(
    () => async (paramSort?: number) => {
      try {
        await administrationService.getUsersList(paramSort);
      } catch (e) {}
    },
    []
  );

  const createUser = useMemo<UseCreateUser>(
    () => async (userInfo: User) => {
      try {
        return await administrationService.createUser(userInfo);
      } catch (e) {
        return false;
      }
    },
    []
  );

  const updateUser = useMemo<UseUpdateUser>(
    () => async (userInfo: User) => {
      try {
        await administrationService.updateUser(userInfo);
      } catch (e) {}
    },
    []
  );

  const deleteUser = useMemo<UseDeleteUser>(
    () => async (userId: number) => {
      try {
        await administrationService.deleteUser(userId);
      } catch (e) {}
    },
    []
  );
  const getExpirePeriod = useMemo<UseGetExpirePeriod>(
    () => async () => {
      try {
        await administrationService.getExpirePeriod();
      } catch (e) {}
    },
    []
  );
  const setExpirationPeriod = useMemo<UseSetExpirePeriod>(
    () => async (period: string) => {
      try {
        await administrationService.setExpirePeriod(period);
      } catch (e) {}
    },
    []
  );

  return [users, pendind, getUsersList, createUser, updateUser, deleteUser, setExpirationPeriod, getExpirePeriod, expirePeriod];
}
